// import React from 'react'

// const PremiumCouponsBanner = () => {
//   return (
//     <div>
      
//     </div>
//   )
// }

// export default PremiumCouponsBanner



import React from 'react';
import styled from 'styled-components';

const PremiumCouponsBanner = () => {
  return (
    <Wrapper>
      <Content>
        <p>Premium Coupons & Offers</p>
      </Content>
    </Wrapper>
  );
};

export default PremiumCouponsBanner;

// Styled Components
const Wrapper = styled.section`
  background-color: #cce7ed;
  width: 100%;
  padding: 14px 20px;
  display: flex;
  justify-content: center;
  @media(max-width:480px){
    padding: 6px 15px;
  }
`;

const Content = styled.div`
  width: 100%;
  max-width: 1280px;
  padding: 0 30px;

  p {
    margin: 0;
    font-weight: bold;
    font-size: 20px;
    color: rgb(83, 83, 83);
  }

  @media (max-width: 768px) {
    p {
      font-size: 16px;
    }
  }

  @media (max-width: 480px) {
    padding: 0 5px;
    p {
      font-size: 14px;
    }
  }
`;


